import { IDynamicTableParams } from 'components/DynamicTable';
import instance from 'api';

// Матрица сотрудник–ЖК–должность (ТЗ 3.5). Контроллер chronaMatrix на бэке.
export const getMatrix = (filters: IDynamicTableParams) =>
  instance()
    .post('chronaMatrix/report', filters)
    .then((response) => response.data);

export const getAvailableColumns = () =>
  instance()
    .post('chronaMatrix/availableColumns')
    .then((response) => response.data);

export const getFilterColumns = () =>
  instance()
    .post('chronaMatrix/availableGroupColumns')
    .then((response) => response.data);

/** Справочники для диалога добавления: {employees, objects, positions}. */
export const getDictionaries = () =>
  instance()
    .post('chronaMatrix/dictionaries')
    .then((response) => response.data);

export const saveAssignment = (data: {
  userId: string;
  realEstateGuid: string;
  positionId: number;
  /** true — отметка обязательна, false — опциональна, undefined — не менять настройку. */
  isAppBlockEnabled?: boolean;
}) =>
  instance()
    .post('chronaMatrix/save', data)
    .then((response) => response.data);

export const removeAssignment = (chronaAssignmentId: number) =>
  instance()
    .post('chronaMatrix/archive', { chronaAssignmentId })
    .then((response) => response.data);

/**
 * Персональные настройки сотрудника: блокировка интерфейса мобильного приложения
 * без отметки о приходе. Действует на сотрудника целиком, на всех его объектах.
 */
export const setAppBlock = (userId: string, isAppBlockEnabled: boolean) =>
  instance()
    .post('chronaEmployee/save', { userId, isAppBlockEnabled })
    .then((response) => response.data);

/**
 * Скольких сотрудников затронет массовое переключение.
 * Спрашиваем до применения: на пилоте это тысячи людей, и охват надо видеть заранее.
 */
export const bulkAppBlockPreview = (payload: { userIds?: string[]; filterColumns?: any[] }) =>
  instance()
    .post('chronaEmployee/bulkPreview', payload)
    .then((response) => response.data as number);

/**
 * Массовое включение/выключение блокировки. `isAppBlockEnabled: false` — рычаг
 * отката пилота: отфильтровать сотрудников нужного ЖК и снять флаг группой.
 */
export const bulkSetAppBlock = (payload: { userIds?: string[]; filterColumns?: any[]; isAppBlockEnabled: boolean }) =>
  instance()
    .post('chronaEmployee/bulkSetAppBlock', payload)
    .then((response) => response.data as number);

/** Предпросмотр массового назначения исполнителей ЖК. */
export const previewExecutorsImport = (payload: {
  realEstateGuid: string;
  positionIds?: number[];
  addPositionsToZone?: boolean;
}) =>
  instance()
    .post('chronaMatrix/importExecutors/preview', payload)
    .then((response) => response.data);

/** Применение массового назначения. expectedToCreate защищает от гонки. */
export const applyExecutorsImport = (payload: {
  realEstateGuid: string;
  positionIds?: number[];
  addPositionsToZone?: boolean;
  /** null - не менять персональную настройку отметки. */
  isAppBlockEnabled?: boolean | null;
  expectedToCreate?: number;
}) =>
  instance()
    .post('chronaMatrix/importExecutors/apply', payload)
    .then((response) => response.data);

/** Откат прогона импорта: снимает ровно ту партию, что он завёл. */
export const rollbackExecutorsImport = (importBatchId: string) =>
  instance()
    .post('chronaMatrix/importExecutors/rollback', { importBatchId })
    .then((response) => response.data as number);
